import styled from 'styled-components';

import Icon from '@/components/Base/Icon';
import {
  colorBlack900,
  colorPrimary50,
  colorWhite,
  fontFamilyPrimary,
  mediaQueryMobileLargeMin,
} from '@/styleUtils';

export const Wrapper = styled.div`
  flex-shrink: 0;
  width: max-content;
  position: relative;
`;

export const ToggleBtn = styled.div`
  height: 24px;
  position: relative;
  padding-right: 24px;
  gap: 8px;
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex: 0;

  &::after {
    content: '';
    border-style: solid;
    border-width: 5px 5px 0 5px;
    border-color: ${colorBlack900} transparent transparent transparent;
    height: 0;
    width: 0;
    position: absolute;
    right: 6px;
    top: calc(50% - 1.5px);
  }
`;

export const StyledIcon = styled(Icon)`
  width: 18px;
  color: ${colorBlack900};
`;

export const ActiveSortTypeLabel = styled.span`
  font: normal 400 14px/24px ${fontFamilyPrimary};
  color: ${colorBlack900};
`;

export const OptionsWrapper = styled.div`
  display: ${({ $showOptions }) => ($showOptions ? 'flex' : 'none')};
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100vh;
  z-index: 10000;
  padding: 0 16px;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.15);

  @media ${mediaQueryMobileLargeMin} {
    position: absolute;
    top: 100%;
    background: transparent;
    padding: 0;
    height: auto;
    width: 300px;
  }
`;

export const Options = styled.div`
  position: static;
  width: 100%;
  max-height: 312px;
  padding: 8px 0;
  overflow: auto;
  background-color: ${colorWhite};
  box-shadow:
    rgba(0, 0, 0, 0.04) 0 4px 8px 0,
    rgba(0, 0, 0, 0.14) 0 2px 6px;
  border-radius: 4px;

  &::-webkit-scrollbar {
    width: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    max-height: 50px;
  }

  &::-webkit-scrollbar-track {
    background-color: ${colorWhite};
  }

  @media ${mediaQueryMobileLargeMin} {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
  }
`;

export const Option = styled.label`
  display: block;
`;

export const OptionInput = styled.input`
  display: none;
`;

export const OptionLabel = styled.span`
  cursor: pointer;
  display: block;
  font-size: 16px;
  font-weight: 400;
  line-height: 28px;
  margin: 0;
  overflow: hidden;
  padding: 10px 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;

  &:hover,
  &.focus-visible {
    background-color: ${colorPrimary50};
    color: ${colorBlack900};
  }

  input:checked + & {
    background-color: ${colorPrimary50};
  }
`;
